import React from 'react';
import { motion } from 'framer-motion';
import MenuItemCard from './MenuItemCard';

const MenuSection = ({ 
  title, 
  items, 
  onAddToOrder, 
  className = "", 
  customerPhone, 
  favoriteItems = [], 
  onFavoriteChange,
  isGuest = false,
  headerAction = null,
  belowTitle = null,
}) => {
  if (!items || items.length === 0) return null;

  return (
    <motion.div 
      className={`mb-6 sm:mb-8 lg:mb-12 ${className}`}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2 mb-3 sm:mb-5">
        <div className="flex flex-wrap items-center gap-2 sm:gap-3 min-w-0">
          <h2 className="text-lg sm:text-2xl md:text-3xl font-bold text-stone-800">
            {title}
          </h2>
          <div className="hidden sm:block w-px h-6 bg-stone-200 flex-shrink-0" aria-hidden />
          <span className="text-xs sm:text-sm text-stone-600 bg-amber-50 border border-amber-100 px-2 sm:px-3 py-1 rounded-full font-medium">
            {items.length} items
          </span>
        </div>
        {headerAction ? (
          <div className="flex-shrink-0">{headerAction}</div>
        ) : null}
      </div>
      {belowTitle ? <div className="mb-3 sm:mb-4">{belowTitle}</div> : null}
      
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-2 sm:gap-4 md:gap-5 lg:gap-6 min-w-0">
        {items.map((item, index) => (
          <motion.div
            key={item._id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: Math.min(index * 0.05, 0.3) }}
            className="h-full"
          >
            <MenuItemCard 
              item={item} 
              onAddToOrder={onAddToOrder}
              customerPhone={customerPhone}
              isFavorite={favoriteItems.includes(item._id)}
              onFavoriteChange={onFavoriteChange}
              isGuest={isGuest}
            />
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default MenuSection;